import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonInput, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteStore, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { deleteFirmBank, getFirmBanksList, statusChangeFirmBank, updateFirmBank } from '_services/accountsServices/firmServices';
import { utils } from 'helper';
import AddEditFirmBankModel from 'modals/AddEditFirmBankModel/AddEditFirmBankModel';

const FirmDetailsBankSection = () => {
    useDocumentTitle("Bank Firm Details | T360");

    const { settingChild } = useContext(UserContext);
    const [bankFirmModelData, setBankFirmModelData] = useState(false);
    const [bankDataList, setBankDataList] = useState([])
    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const prevFilterRef = useRef();
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    const toggleStoreModelData = () => {
        setBankFirmModelData(!bankFirmModelData);
    };

    const getDataFirmBankList = async () => {
        try {
            let object = {
                ...filter,
                firm_id: StorageService.getFirmId(),
            }
            delete object.limit;
            delete object.offset;
            const res = await getFirmBanksList(object);
            if (res?.responseCode == 200) {
                setBankDataList(res?.data);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        const prevFilter = prevFilterRef.current;
        if (
            JSON.stringify(prevFilter) !== JSON.stringify(filter)
        ) {
            getDataFirmBankList();
            prevFilterRef.current = filter;
        }
    }, [filter, bankFirmModelData])

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteBank = async () => {
        setLoading(true);
        try {
            let object = {
                firm_id: StorageService.getFirmId(),
                bank_id: isDelete?._id
            }
            const res = await deleteFirmBank(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                getDataFirmBankList();
                setLoading(false);
                setIsDelete(false);
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteBank,
        isLoadding: loading,
    }

    let bankFirmModelProps = {
        isOpen: bankFirmModelData,
        closeModal: (e) => setBankFirmModelData(false),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: bankFirmModelData?.isDetails ? "View Bank Account" : (bankFirmModelData?._id ? 'Update Bank Account' : 'Add Bank Account'),
        submitTitle: bankFirmModelData?.isDetails ? "View Bank Account" : (bankFirmModelData?._id ? 'Update Bank Account' : 'Add Bank Account'),
        footerPart: bankFirmModelData?.isDetails ? true : false,
        hideFooterSumbmitBtn: bankFirmModelData?.isDetails ? true : false,
        hideCompletelyFoolter: bankFirmModelData?.isDetails ? true : false,
        callListApi: () => getDataFirmBankList(),
    }

    const handleStatusEvent = async (data, ind) => {
        try {
            let payload = {
                firm_id: StorageService.getFirmId(),
                bank_id: data?._id,
                print_on_invoice: data?.print_on_invoice === true ? false : true,
            }
            const res = await updateFirmBank(payload);
            if (res?.responseCode === 200) {
                toast.success(`${res?.responseMessage}`);
                getDataFirmBankList();
                // let list = [...contactList];
                // list.splice(ind, 1, { ...list[ind], active: data?.active === 1 ? 0 : 1 })
                // setContactList(list);
            }
        } catch (error) {
            toast.error(`Invalid Request !!`);
        }
    };

    const columns = [
        { header: "Account Number", accessor: "account_number" },
        { header: "Bank Name", accessor: "bank_name" },
        { header: "IFSC Code", accessor: "ifsc_code" },
        { header: "Branch Name", accessor: "branch_name" },
        { header: "Status", accessor: "print_on_invoice" },
        { header: "Actions", accessor: "action" }
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            account_number: <span className='_tblText _style_ancer' onClick={(e) => setBankFirmModelData({ ...item, isDetails: true })}>
                <a className='_avPointer'>
                    {item?.account_number ? item?.account_number : '-'} &nbsp;
                </a>
            </span>,
            bank_name: <>{item?.bank_name ? item?.bank_name : '-'}</>,
            ifsc_code: <>{item?.ifsc_code ? item?.ifsc_code : '-'}</>,
            branch_name: <>{item?.branch_name ? item?.branch_name : '-'}</>,
            print_on_invoice: <>
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "125px", justifyContent: 'flex-start' }}
                >
                    <input
                        className="form-check-input _pi_ter"
                        type="checkbox"
                        name="actStatus"
                        id={`actStatus-${item._id}`}
                        checked={item?.print_on_invoice === true ? true : false}
                        onChange={(e) => handleStatusEvent(item, i)}
                        disabled={item?.print_on_invoice === true ? true : false}
                    />
                    {/* <span className={item?.print_on_invoice === true ? 'green_status' : 'red_status'}>
                        {item?.print_on_invoice === true ? "On" : "Off"}
                    </span> */}
                </div>
            </>,
            action: (
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "100px" }}
                >
                    <span className='_samAnchor' onClick={(e) => setBankFirmModelData({ ...item, isDetails: true })}>
                        <span className='viewIcon_avt'>
                            <AiOutlineEye color="green" />
                        </span>
                    </span>

                    <div
                        onClick={(e) => setBankFirmModelData({ ...item, isDetails: false })}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color="blue" />
                            </span>

                        </span>
                    </div>

                    {/* <div
                        onClick={(e) => deleteHandler(item)}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='deleteIcon_avt'>
                                <FaRegTrashCan color='red' />
                            </span>

                        </span>
                    </div> */}
                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    return (
        <div className="__profilCmp_main">
            <div className='pd_manufactoer'>
                <div className='__filtsTb_flexMain _dix_jstBtwn'>
                    <div className='__filtsTb_flex'>
                        <div className='__fInx_bx'>
                            <CommonInput
                                type="search"
                                label='Search'
                                placeholder='Search'
                                name='search'
                                value={filter.search}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
                            />
                        </div>
                        {(filter.search) &&
                            <div>
                                <button
                                    className='manuRsret'
                                    onClick={() => setFilter((s) => ({ ...s, search: '' }))}
                                >
                                    Clear
                                </button>
                            </div>}
                    </div>
                    <button className="anime-btn _addComm_btn _tnx_firmBxn" onClick={() => setBankFirmModelData(true)}>
                        + Add Bank
                    </button>
                </div>
            </div>

            <div className='_tabWith_outTab'>
                <BootstrapTable
                    columns={columns}
                    data={rowListData(bankDataList?.length > 0 ? bankDataList : [])}
                    isLoading={loading}
                />

                {(totalItems > 0 && bankDataList?.length) ? <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div> : <></>}
            </div>

            {
                bankFirmModelData
                && (
                    <AddEditFirmBankModel {...bankFirmModelProps} />
                )
            }

            {
                isDelete?._id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }
        </div>
    )
}

export default FirmDetailsBankSection